<template>
    <div>
        <a-row>
            <a-col :span="1"/>
            <a-col :span="2">
                车牌号：
            </a-col>
            <a-col :span="4">
                <a-input v-model.trim="carNo"/>
            </a-col>
            <a-col :span="1"/>
            <a-col :span="2">
                开始时间：
            </a-col>
            <a-col :span="4">
                <my-date :date-value.sync="startDt" :placeholder="'开始时间'"/>
            </a-col>
            <a-col :span="1"/>
            <a-col :span="2">
                结束时间：
            </a-col>
            <a-col :span="4">
                <my-date :date-value.sync="endDt" :placeholder="'结束时间'"/>
            </a-col>
            <a-col :span="2 ">
                <a-button type="primary" @click="look">
                    查询
                </a-button>
            </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="data.data" bordered :scroll="{y:'65vh'}" :pagination="false" rowKey="id"/>
        <my-page :data="data" @change="onChange"/>
    </div>
</template>

<script>
    import {queryStatisticsByCar} from './js/ApiQuery'
    import {getNowDateString} from "../../config/Config";

    const columns = [
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'orderNo',
            ellipsis: true,
        },
        {
            title: '车牌号',
            dataIndex: 'carNo',
            key: 'carNo',
            ellipsis: true,
        },
        {
            title: '收取次数',
            dataIndex: 'collectCount',
            key: 'collectCount',
            ellipsis: true,
        },
        {
            title: '收取总重',
            dataIndex: 'collectWeight',
            key: 'collectWeight',
            ellipsis: true,
        },
        {
            title: '感染类',
            dataIndex: 'infectWeight',
            key: 'infectWeight',
            ellipsis: true,
        },
        {
            title: '病理类',
            dataIndex: 'pathologyWeight',
            key: 'pathologyWeight',
            ellipsis: true,
        },
        {
            title: '损伤类',
            dataIndex: 'damageWeight',
            key: 'damageWeight',
            ellipsis: true,
        },
        {
            title: '药物类',
            dataIndex: 'medicineWeight',
            key: 'medicineWeight',
            ellipsis: true,
        },
        {
            title: '化学类',
            dataIndex: 'chemistryWeight',
            key: 'chemistryWeight',
            ellipsis: true,
        },
        {
            title: '告警次数',
            dataIndex: 'alarmCount',
            key: 'alarmCount',
            ellipsis: true,
        },
    ];
    export default {
        data() {
            return {
                columns,
                data: {},
                startDt: getNowDateString(),
                endDt: getNowDateString(),
                carNo: '',
            }
        },
        methods: {
            getData(parameter) {
                queryStatisticsByCar(parameter).then(res => {
                    console.log(res);
                    this.data = res.data
                })
            },
            // 查询
            look() {
                let baseDto = {
                    queryStartDate: this.startDt,
                    queryEndDate: this.endDt
                };
                this.getData({baseDto:baseDto,carNo:this.carNo});
            },

            // 分页
            onChange(page) {
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                    queryStartDate: this.startDt,
                    queryEndDate: this.endDt
                };
                this.getData({baseDto: baseDto});
            },
        },
        created() {
            let baseDto = {
                queryStartDate: this.startDt,
                queryEndDate: this.endDt
            };
            this.getData({baseDto:baseDto});
        }
    }
</script>

<style scoped>

</style>
